import React, { useState, useEffect, useRef } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Input,
  Pagination,
} from "../../../../../../../_metronic/_partials/controls";
import AddIcon from "@material-ui/icons/Add";
import { Field, Formik } from "formik";
import * as bankImportActiosn from "../../../../../Donation/_redux/bank-import/bankImportAction";
import { toast } from "react-toastify";
import {
  toastOption,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../../_metronic/_helpers";
import { currencyFormatter } from "../../../pickup/pickup-detail/pickup-detail-table/column-formatters";
import moment from "moment";

export default function SelectBankStatementModal({
  show,
  onHide,
  selectedBankMutation,
}) {
  // const formRef = useRef();

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "20", value: 20 },
    { text: "50", value: 50 },
  ];

  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    filter: {
      name: "",
      kd_cc: "",
      email: "",
      hp: "",
      city: "",
      provinsi: "",
      type: "",
      branch: "",
      start_date: "",
      end_date: "",
      is_letter: "",
      filterCabang: true,
      is_reconcile: true,
    },
  });

  useEffect(() => {
    if (!show) {
      setQueryParams((prevState) => ({
        ...prevState,
        pageNumber: 1,
        pageSize: 10,
        filter: {
          is_reconcile: true,
        },
      }));
    }
  }, [show]);

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Donatur Action
    if (show) {
      // formRef.current.resetForm();
      dispatch(bankImportActiosn.fetchBankImport(queryParams));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, dispatch, show]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.bankImport }),
    shallowEqual
  );

  const { totalCount, entities, listLoading, error } = currentState;

  if (error !== undefined) {
    toast.error(error, toastOption);
  }

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  const applyFilter = (value) => {
    const { name, hp, email } = value;
    setQueryParams((prevState) => ({
      ...prevState,
      filter: {
        name,
        hp,
        email,
      },
    }));
  };

  // Table columns
  const columns = [
    {
      dataField: "trx_date",
      text: "Tanggal",
    },
    {
      dataField: "message",
      text: "Pesan Bank",
    },
    {
      dataField: "created_at",
      text: "Tanggal Import",
      formatter: (cell) => {
        return moment(cell).format("YYYY-MM-DD");
      },
    },
    {
      dataField: "amount",
      text: "Nominal",
      classes: "text-right",
      headerClasses: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
    {
      classes: "text-right",
      formatter: (cell, row) => {
        return (
          <>
            <OverlayTrigger
              overlay={<Tooltip id="detail-trx-tooltip">Tambah </Tooltip>}
            >
              <a
                className="btn btn-icon btn-light btn-hover-success btn-sm mb-1 mr-1"
                onClick={() => selectedBankMutation(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-success">
                  <AddIcon />
                </span>
              </a>
            </OverlayTrigger>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={onHide}
        aria-labelledby="modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>Pilih Transaksi</h4>
        </Modal.Header>
        <Modal.Body>
          {/* <Formik
            enableReinitialize={true}
            initialValues={{}}
            onSubmit={(values) => applyFilter(values)}
            innerRef={formRef}
          >
            {({ handleSubmit, setFieldValue, values }) => (
              <>
                <div className="row">
                  <div className="col">
                    <Field
                      name="name"
                      component={Input}
                      onChange={(e) => {
                        setFieldValue("name", e.target.value);
                        handleSubmit();
                      }}
                      label="name"
                      placeholder="Masukkan nama..."
                    />
                  </div>
                  <div className="col">
                    <Field
                      name="hp"
                      component={Input}
                      onChange={(e) => {
                        setFieldValue("hp", e.target.value);
                        handleSubmit();
                      }}
                      label="hp"
                      placeholder="Masukkan hp..."
                    />
                  </div>
                  <div className="col">
                    <Field
                      name="email"
                      component={Input}
                      onChange={(e) => {
                        setFieldValue("email", e.target.value);
                        handleSubmit();
                      }}
                      label="email"
                      placeholder="Masukkan email..."
                    />
                  </div>
                </div>
              </>
            )}
          </Formik> */}
        </Modal.Body>
        <Modal.Body>
          <PaginationProvider pagination={paginationFactory(paginationOptions)}>
            {({ paginationProps, paginationTableProps }) => {
              return (
                <Pagination
                  isLoading={listLoading}
                  paginationProps={paginationProps}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    bordered={false}
                    remote
                    keyField="uuid"
                    data={entities === null ? [] : entities}
                    columns={columns}
                    onTableChange={getHandlerTableChange(setQueryParams)}
                    {...paginationTableProps}
                  >
                    <PleaseWaitMessage entities={entities} />
                    <NoRecordsFoundMessage entities={entities} />
                  </BootstrapTable>
                </Pagination>
              );
            }}
          </PaginationProvider>
        </Modal.Body>
      </Modal>
    </>
  );
}
